module.exports = {"title":"Delete ticket","description":"Are you sure you want to delete that ticket?","yes":"Yes","no":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/ReleaseRefundTicketModal/locales/fr.json
// module id = 1443
// module chunks = 0